import MegaMenu from "../MegaMenu/MegaMenu.jsx";
import AuxiliaryNav from "../AuxiliaryNav/AuxiliaryNav.jsx";

import { object, array } from "prop-types";
import { flyoutNavShape } from "./primaryNavTypes.js";

const propTypes = {
  dataExplorer: object,
  navItems: flyoutNavShape,
  search: object,
  draftReport: array,
};

const PrimaryNav = (props) => {
  const { dataExplorer, navItems, search, draftReport } = props;

  return (
    <div className="global-header__primary-nav--desktop">
      <MegaMenu navItems={navItems} />
      <div className="global-header__desktop-auxiliary-nav">
        <AuxiliaryNav
          draftReport={draftReport}
          search={search}
          dataExplorer={dataExplorer}
        />
      </div>
    </div>
  );
};

PrimaryNav.propTypes = propTypes;
export default PrimaryNav;
